import { createBrowserRouter, Navigate } from 'react-router';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AppShell } from '@/components/layout/AppShell';
import { Root } from '@/routes/Root';
import { SgcDashboard } from '@/features/sgc-dashboard/SgcDashboard';
import { MasterList } from '@/features/master-list/MasterList';
import { DocumentDossier } from '@/features/document-dossier/DocumentDossier';
import { DocumentEditor } from '@/features/document-editor/DocumentEditor';
import { RolesAccess } from '@/features/roles-access/RolesAccess';
import { Users } from '@/features/users/Users';
import { Catalogs } from '@/features/catalogs/Catalogs';
import { Traceability } from '@/features/traceability/Traceability';
import { Training } from '@/features/training/Training';
import { Notifications } from '@/features/notifications/Notifications';
import { TimeStudyScreen } from '@/features/time-study/TimeStudyScreen';
import { WatermarkScreen } from '@/features/watermark/WatermarkScreen';
import { Login } from '@/routes/Login';
import { RedirectKeepingQuery } from '@/routes/RedirectKeepingQuery';
import { Callback } from '@/routes/Callback';
import { AccessDenied } from '@/routes/AccessDenied';
import { NotFound } from '@/routes/NotFound';

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/callback', element: <Callback /> },
      { path: '/access-denied', element: <AccessDenied /> },
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard', element: <SgcDashboard /> },
          { path: 'documentos', element: <MasterList /> },
          { path: 'documentos/:id', element: <DocumentDossier /> },
          { path: 'documentos/:id/editor', element: <DocumentEditor /> },
          { path: 'estudio-de-tiempos', element: <TimeStudyScreen /> },
          { path: 'capacitaciones', element: <Training /> },
          { path: 'configuracion/usuarios', element: <Users /> },
          { path: 'configuracion/roles', element: <RolesAccess /> },
          { path: 'configuracion/catalogos', element: <Catalogs /> },
          { path: 'configuracion/trazabilidad', element: <Traceability /> },
          { path: 'notificaciones', element: <Notifications /> },
          { path: 'marca-de-agua', element: <WatermarkScreen /> },
          // Ruta anterior en inglés: los enlaces viejos siguen funcionando.
          { path: 'notifications', element: <RedirectKeepingQuery to="/notificaciones" /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
